import React, { Fragment } from "react";
import Box from '@mui/material/Box';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import { notificationValidations } from "./notificationConstant";

const messageControlSx = {
    flex: "0 1 auto",
    minWidth: 0,
    "& textarea": { boxSizing: "border-box" },
};

const EmailNotification = ({
    messageData = { subject: "", html: "", text: "" },
    handleMessageData,
}) => {
    return (
        <Fragment>
            <label className="title" style={{ fontSize: "14px", fontWeight: "bold" }}>Message</label>
            <div className="content-block position-relative send-notification-message" style={{ marginTop: "10px" }}>
                <div className="py-15">
                    <div className="send-notification-field-row">
                        <label className="title" style={{ color: 'black', fontSize: '14px' }}>Subject:</label>
                        <Box sx={messageControlSx}>
                            <TextareaAutosize
                                aria-label="minimum height"
                                placeholder="Write a Message"
                                style={{ height: '50px', padding: "10px", width: "100%", minWidth: 280, maxWidth: 500, boxSizing: "border-box" }}
                                onChange={(e) => {
                                    handleMessageData("subject", e?.target?.value?.substring(0, notificationValidations?.email?.subject?.maxLength))
                                }}
                                value={messageData?.subject}
                            />
                            <p>{(messageData?.subject?.length > notificationValidations?.email?.subject?.maxLength ? notificationValidations?.email?.subject?.maxLength : messageData?.subject?.length) + "/" + notificationValidations?.email?.subject?.maxLength}</p>
                        </Box>
                    </div>
                    <div className="send-notification-field-row">
                        <label className="title" style={{ color: 'black', fontSize: '14px' }}>HTML:</label>
                        <Box sx={messageControlSx}>
                            <TextareaAutosize
                                aria-label="minimum height"
                                placeholder="Write a Message"
                                style={{ height: '200px', padding: "10px", width: "100%", minWidth: 280, maxWidth: 500, boxSizing: "border-box" }}
                                onChange={(e) => {
                                    handleMessageData('html', e.target.value?.substring(0, notificationValidations?.email?.html?.maxLength))
                                }}
                                value={messageData?.html}
                            />
                            <p>{(messageData?.html?.length > notificationValidations?.email?.html?.maxLength ? notificationValidations?.email?.html?.maxLength : messageData?.html?.length) + "/" + notificationValidations?.email?.html?.maxLength}</p>
                        </Box>
                    </div>
                    <div className="send-notification-field-row">
                        <label className="title" style={{ color: 'black', fontSize: '14px' }}>Text:</label>
                        <Box sx={messageControlSx}>
                            <TextareaAutosize
                                aria-label="minimum height"
                                placeholder="Write a Message"
                                style={{ height: '100px', padding: "10px", width: "100%", minWidth: 280, maxWidth: 500, boxSizing: "border-box" }}
                                onChange={(e) => {
                                    handleMessageData('text', e.target.value?.substring(0, notificationValidations?.email?.text?.maxLength))
                                }}
                                value={messageData?.text}
                            />
                            <p>{(messageData?.text?.length > notificationValidations?.email?.text?.maxLength ? notificationValidations?.email?.text?.maxLength : messageData?.text?.length) + "/" + notificationValidations?.email?.text?.maxLength}</p>
                        </Box>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}


export default EmailNotification